// @ts-nocheck
import React from 'react';
import EmailsList from './components/EmailsList';
import ActionBar from '../../layout/ActionBar';
import { usePageTitle } from '../../../util/pageTitle';

export default function Emails() {
  const [pageTitle, setPageTitle] = usePageTitle(['Emails', 'Settings']);
  return (
    <>
      <ActionBar></ActionBar>
      <EmailsList />
    </>
  );
}
